import React, { useEffect } from 'react';
import styled from 'styled-components';
import Banner from '../components/Banner';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Guarantee from '../components/Guarantee';
import FAQ from '../components/FAQ';
import Capabilities from '../components/Capabilities';
import CTA from '../components/CTA';
import Pricing from '../components/Pricing';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const StickyWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 200;
  width: 100%;
`;

const Home = () => {
  // Simple listener to handle hash scrolling natively since react-router sometimes struggles 
  // with internal hash links on first load.
  useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        const id = window.location.hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <StickyWrapper>
        <Banner />
        <Header />
      </StickyWrapper>
      <Hero />
      <Guarantee />
      <FAQ />
      <Capabilities />
      <CTA />
      <Pricing />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
